module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 12 12"},"content":"<path fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M7 5h4a1 1 0 0 1 0 2H7v4a1 1 0 0 1-2 0V7H1a1 1 0 0 1 0-2h4V1a1 1 0 0 1 2 0v4z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/new-plus.svg
// module id = 1427
// module chunks = 0